// Maps to backend/routers/group.py
import { useState, useEffect, useCallback } from 'react';
import { env } from '../utils/env';

export interface GroupCategory {
    id: number;
    name: string;
    description?: string;
    icon?: string;
    color?: string;
}

export const useGroupCategories = (accessToken: string, groupId?: number | string) => {
    const [categories, setCategories] = useState<GroupCategory[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchCategories = useCallback(async () => {
        if (!accessToken || !groupId) {
            setCategories([]);
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            setError(null);

            const response = await fetch(`${env.API_URL}/api/groups/${groupId}/category`, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch group categories: ${response.status}`);
            }

            const data = await response.json();
            setCategories(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error('Error fetching group categories:', err);
            setError(err instanceof Error ? err.message : 'Failed to load group categories');
            setCategories([]);
        } finally {
            setLoading(false);
        }
    }, [accessToken, groupId]);

    useEffect(() => {
        fetchCategories();
    }, [fetchCategories]);

    return { categories, loading, error, refresh: fetchCategories };
}; 